import { BrandLogoContainer, BrandingTextContainer } from 'components/layout/BrandLogo/components';

import Divider from 'components/common/Divider';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';
import useURLs from 'hooks/use-url';

export default function BrandLogo(): JSX.Element {
  const translation = useTranslation();
  const urls = useURLs();

  if (!translation) {
    return <Spin />;
  }

  return (
    <BrandLogoContainer>
      <a target='_blank' rel='noopener noreferrer' href={urls?.logo.url}>
        <img alt={urls?.logo.alt} src={`./config/icons/${translation.common.icons.logo.src}`} height={56} />
      </a>
      <Divider className='navbar-brand-logo-divider' type='vertical' />
      <BrandingTextContainer className='navbar-brand-logo-text' to='/'>
        <span>Credit</span>
        <span>calculator</span>
      </BrandingTextContainer>
    </BrandLogoContainer>
  );
}
